import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useModalStyles = makeStyles((theme: Theme) =>
	createStyles({
		checkbox: {
			userSelect: "none",
			"& .MuiOutlinedInput-root": {
				height: "51px",
			},
			margin: "8px 0px",
		},
		modalBody: {},
		title: {
			fontSize: 15,
		},
		chip: {
			margin: 2,
		},
		errorLabel: {
			fontSize: 12,
			color: "#F44336",
		},
		colorPicker: {
			border: "1px solid #c4c4c4",
			borderRadius: "4px",
			padding: "3.5px",
		},
	}),
);
